import React from 'react';
import { captureException } from 'Utils/errorTracking';
import TextBlock from 'Components/TextBlock';
import SectionHeader from 'Components/SectionHeader';
import ContentFrame from 'Components/ContentFrame';
import Button from 'Components/Button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    captureException(error, info);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    /*
      NOTE: not using ConnectedFormattedMessage for the text because this exists outside of
      the store and intl contexts
    */
    if (hasError) {
      return (
        <div>
          <main className="Page__content">
            <ContentFrame pageType="with-graphic" size="medium">
              <div className="ContentFrame__body">
                <SectionHeader title="Error" />
                <TextBlock description="Whoops, something went wrong! We have recorded this error and are working to fix it" />
              </div>
              <Button
                clickHandler={() => {
                  window.location.reload();
                }}
                buttonType="primary"
                label="reload"
              />
            </ContentFrame>
          </main>
        </div>
      );
    }
    return children;
  }
}

export default ErrorBoundary;
